import React from 'react'
import { Collapse } from 'reactstrap'

import PLInput from './PLInput'
import { I18n } from 'react-redux-i18n'
import { TradingPaneValues } from '../types'
import { PriceExtended, TradeCommandType, TradingAccount } from '@bdswiss/mt4-connector'
import Spinner from './Spinner'

export interface Props {
  accountLoaded: boolean
  account?: TradingAccount
  asset: PriceExtended
  locale: string
  tradeType: TradeCommandType
  tradingValues: TradingPaneValues
  onSetTakeProfit: (takeProfit: number) => void
  onSetStopLoss: (stopLoss: number) => void
  onSetPrice: (price: number) => void
  onInputValid: (inputValid: boolean) => void
}

export interface State {
  advancedOpen: boolean
}
// const TradeSettings = ({ accountLoaded, account, asset, locale, tradeType, settings, onSetTakeProfit, onSetStopLoss, onSetPrice}: Props) => {

class TradeSettings extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.toggleAdvanced = this.toggleAdvanced.bind(this)
    this.state = { advancedOpen: this.props.tradingValues.pendingOrderEnabled }
  }

  public render() {
    const {
      accountLoaded,
      account,
      asset,
      locale,
      tradeType,
      tradingValues,
      onSetTakeProfit,
      onSetStopLoss,
      onSetPrice,
      onInputValid,
    } = this.props
    if (!account || !asset) {
      // console.log('Trade settings form loading...');
      return <Spinner />
    }
    const {
      takeProfitEnabled,
      takeProfitInitial,
      takeProfit,
      stopLossEnabled,
      stopLossInitial,
      stopLoss,
      profit,
      profitPercent,
      loss,
      lossPercent,
      pendingOrderEnabled,
      priceInitial,
      price,
    } = tradingValues
    return (
      <div className="mb-4">
        <PLInput
          key={`${tradeType}Profit`}
          type={'profit'}
          enabled={takeProfitEnabled}
          tradeType={tradeType}
          label={I18n.t('takeProfit')}
          asset={asset}
          valueInitial={takeProfitInitial}
          value={takeProfit}
          profitLoss={profit}
          profitLossPercent={profitPercent}
          currency={account!.currency}
          locale={locale}
          setValue={onSetTakeProfit}
          accountLoaded={accountLoaded}
          tradingValues={tradingValues}
          onInputValid={onInputValid}
        />
        <PLInput
          key={`${tradeType}Loss`}
          type={'loss'}
          enabled={stopLossEnabled}
          tradeType={tradeType}
          label={I18n.t('stopLoss')}
          asset={asset}
          valueInitial={stopLossInitial}
          value={stopLoss}
          profitLoss={loss}
          profitLossPercent={lossPercent}
          currency={account!.currency}
          locale={locale}
          setValue={onSetStopLoss}
          accountLoaded={accountLoaded}
          tradingValues={tradingValues}
          onInputValid={onInputValid}
        />
        <div
          onClick={this.toggleAdvanced}
          className="trade-settings-advanced--label d-flex flex-row align-items-center"
          data-cy="advancedSettings"
        >
          <div className={'wt-expander wte' + (this.state.advancedOpen ? '-down' : '-right')}>
            &nbsp;
          </div>
          {I18n.t('tradingPanelAdvancedSettings')}
        </div>
        <Collapse isOpen={this.state.advancedOpen}>
          <div className="AdvancedSettings m-0">
            <PLInput
              key={`${tradeType}Price`}
              type={'price'}
              enabled={pendingOrderEnabled}
              tradeType={tradeType}
              label={I18n.t(/buy/i.test(tradeType) ? 'buyPrice' : 'sellPrice')}
              asset={asset}
              valueInitial={priceInitial}
              value={price}
              profitLoss={profit}
              profitLossPercent={profitPercent}
              currency={account!.currency}
              locale={locale}
              setValue={onSetPrice}
              accountLoaded={accountLoaded}
              onInputValid={onInputValid}
            />
          </div>
        </Collapse>
      </div>
    )
  }

  private toggleAdvanced() {
    this.setState(prevState => ({
      advancedOpen: !prevState.advancedOpen,
    }))
  }
}
export default TradeSettings
